import { render } from "./campus.vue?vue&type=template&id=5a94b44a"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"
script.render = render

export default script